var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWcaRegistrationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m632-30a1 1 0 0 0 -1 1v3h-14v-18h3v1a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-1h3a1 1 0 0 0 1 1 1 1 0 0 0 1-1 2 2 0 0 0 -2-2h-3.184a3 3 0 0 0 -2.816-2h-2a3 3 0 0 0 -2.816 2h-3.184a2 2 0 0 0 -2 2v18a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-3a1 1 0 0 0 -1-1zm-10-15a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v1h-4zm3 8h-5a1 1 0 0 1 -1-1 1 1 0 0 1 1-1h5a1 1 0 0 1 1 1 1 1 0 0 1 -1 1zm-2 3a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1-1 1 1 0 0 1 1-1h2a1 1 0 0 1 1 1zm0 4a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1-1 1 1 0 0 1 1-1h2a1 1 0 0 1 1 1zm15.707-10.707-3-3a1 1 0 0 0 -1.414 0l-10 10a1 1 0 0 0 -.293.707v3a1 1 0 0 0 1 1h3a1 1 0 0 0 .707-.293l10-10a1 1 0 0 0 0-1.414zm-11.121 9.707h-1.586v-1.586l9-9 1.586 1.586z",
    transform: "translate(-615 48)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWcaRegistrationIcon);
export default __webpack_public_path__ + "static/media/wca-registration-icon.7758ff3eae8369e54802ba308c539c2f.svg";
export { ForwardRef as ReactComponent };